import "./EditBlackMasks/EditBlackMasksComponent";
import "./EditVideoStream.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditVideoStreamComponentController from "./EditVideoStreamComponentController";

export default class EditVideoStreamComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditVideoStreamComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/CameraConfigurations/EditVideoStream/EditVideoStream.html";
    }
}

module("mmManagePortal").component("irEditVideoStream", new EditVideoStreamComponent());
